import deepmerge from 'deepmerge';
import { ThemeOptions } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import {Theme} from "@material-ui/core/styles/createMuiTheme";
import {Palette, PaletteOptions} from "@material-ui/core/styles/createPalette";

import {BaseDarkThemeOptions, BaseLightThemeOptions} from '../config/BaseThemeOptions';

export interface DarkPalette extends Palette {
  type: 'dark';
}

export interface LightPalette extends Palette {
  type: 'light';
}

export interface LightTheme extends Theme {
  palette: LightPalette;
}

export interface DarkTheme extends Theme {
  palette: DarkPalette;
}

export interface DualVariantTheme {
  name: string;
  lightTheme: LightTheme;
  darkTheme: DarkTheme;
}

export interface LightPaletteOptions extends PaletteOptions {
  type: 'light';
}

export interface DarkPaletteOptions extends PaletteOptions {
  type: 'dark';
}

export interface LightThemeOptions extends ThemeOptions {
  palette: LightPaletteOptions;
}

export interface DarkThemeOptions extends ThemeOptions {
  palette: DarkPaletteOptions;
}

export const CreateDarkTheme = (paletteOverrides: DarkThemeOptions = { palette: { type: "dark" }}): DarkTheme => {
  return createTheme(deepmerge(BaseDarkThemeOptions, paletteOverrides)) as DarkTheme;
};

export const CreateLightTheme = (paletteOverrides: LightThemeOptions = { palette: { type: "light" }}): LightTheme => {
  return createTheme(deepmerge(BaseLightThemeOptions, paletteOverrides)) as LightTheme;
};
